export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/supervisor.worker.4d78d6f3.worker.js");
}
